module.exports = __webpack_public_path__ + "assets/img/topdiv.97fa7974.png";